import React from 'react';

import {
    rsiStreamedDataSelectors,
    useRsiTileConfigSlice,
} from 'widgets/signalTiles/rsiTile/state';
import { SignalTile } from 'widgets/signalTiles/signalTile/components/SignalTile';

import RsiTileChartHelp from './chart/help/RsiTileChartHelp';
import { rsiTileProps } from 'widgets/signalTiles/rsiTile/components/rsiTileProps';

const { useWidgetStreamData, useWidgetMessages } = rsiStreamedDataSelectors;

export function RsiTile() {
    const { config, dispatchConfigChanged } = useRsiTileConfigSlice();
    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();

    return (
        <SignalTile
            className="RsiTile"
            config={config}
            stream={streamData}
            messages={messages}
            dispatchConfigChanged={dispatchConfigChanged}
            settingsHeader={`RSI Capsule Settings`}
            title="RSI"
            help={<RsiTileChartHelp />}
            {...rsiTileProps}
        />
    );
}
